import axios from 'axios';

import { getCurrentUserEmail } from './userIdentity';

// Crée une instance axios avec des configurations par défaut
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        'Authorization': `Bearer ${process.env.REACT_APP_TOKEN_BACK}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=utf-8'
    },
});

// Ajouter un intercepteur pour gérer le Content-Type et injecter l'identité user
apiClient.interceptors.request.use(
    config => {
        // Si les données sont une instance de FormData, ne pas définir le Content-Type
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        } else {
            config.headers['Content-Type'] = 'application/json';
        }

        // Injecter X-User-Email pour que le backend puisse keyer le tracker de
        // rate limit sur l'utilisateur réel et non sur l'IP du proxy.
        const email = getCurrentUserEmail();
        if (email) {
            config.headers['X-User-Email'] = email;
        }

        // Signaler au backend que la requête provient du panel admin.
        // Le rate limit global ne s'applique qu'à ce contexte (la home et
        // l'édition ne sont pas limitées ; la connexion a son propre authLimiter).
        if (typeof window !== 'undefined' && window.location.pathname.startsWith('/admin')) {
            config.headers['X-Client-Context'] = 'admin';
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    response => response,
    error => {
        handleApiError(error);
        return Promise.reject(error);
    }
);

const handleApiError = (error) => {
    if (error.response) {
        console.error('Status:', error.response.status);
        console.error('Data:', error.response.data);

        // Vérification spécifique pour une erreur liée à la base de données
        if (error.response.data === 'Database connection error') {
            console.error('Erreur de connexion à la base de données. Veuillez réessayer plus tard.');
        }
    } else {
        console.error('Error Message:', error.message);
    }
};

export default apiClient;